import { useState, useCallback } from 'react';
import { templateApi } from '../services/api.js';
import { log } from '../utils/environment.js';

export const useTemplateLoader = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadTemplate = useCallback(async (templateSlug) => {
    setLoading(true);
    setError(null);
    
    try {
      log.info('Loading template:', templateSlug);
      
      // Get template from API
      const template = await templateApi.getTemplateBySlug(templateSlug);
      
      if (!template) {
        throw new Error(`Template "${templateSlug}" not found`);
      }
      
      log.info('Found template:', template.name);
      
      // Format template for editor
      const formattedTemplate = {
        id: template.slug,
        name: template.name,
        content: template.content || '',
        design: {
          fontFamily: template.design_data?.fontFamily || 'Inter, system-ui',
          fontSize: template.design_data?.fontSize || 14,
          lineHeight: template.design_data?.lineHeight || 1.6,
          letterSpacing: template.design_data?.letterSpacing || 'normal',
          accentColor: template.design_data?.accentColor || '#1ca29b',
          backgroundColor: template.design_data?.backgroundColor || '#ffffff',
          textColor: template.design_data?.textColor || '#2d3748',
          padding: template.design_data?.padding || '40px',
          margin: template.design_data?.margin || '0px'
        }
      };
      
      log.info('Formatted template ready:', formattedTemplate.name);
      return formattedTemplate;
      
    } catch (err) {
      log.error('Template loading error:', err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const getAllTemplates = useCallback(async (params = {}) => {
    try {
      const templates = await templateApi.getTemplates(params);
      return templates;
    } catch (error) {
      log.error('Error getting templates:', error);
      return [];
    }
  }, []);

  const getTemplateCategories = useCallback(async () => {
    try {
      const categories = await templateApi.getTemplateCategories();
      return categories;
    } catch (error) {
      log.error('Error getting template categories:', error);
      return [];
    }
  }, []);

  return {
    loadTemplate,
    getAllTemplates,
    getTemplateCategories,
    loading,
    error
  };
};